<aside
  class="ai-disclaimer"
  role="note"
  data-ai-generated="true"
  data-html2canvas-ignore="true"
>
  <mat-icon class="ai-disclaimer__icon" aria-hidden="true"
    >auto_awesome</mat-icon
  >
  <p class="ai-disclaimer__text">{{ text }}</p>
</aside>
